import { FC, PropsWithChildren, ReactNode, useEffect, useState } from 'react';

import { UserActionTypes } from './actions/userActions';
import { channelLogoutRunning } from './subjects/logout';
import { useBusinessLayer } from './business-logic';

interface ILogoutWrapperProps extends PropsWithChildren {
	logoutEl: ReactNode;
}

/*
 We use this wrapper to unmount the application during logout, thereby preventing the execution of any effects
  that might interact with the database and slow down the logout process
  TODO maybe this wrapper is no longer needed in the rxdb@16
 */
export const LogoutWrapper: FC<ILogoutWrapperProps> = ({
	children,
	logoutEl,
}) => {
	const [isLogout, setLogout] = useState(false);
	const { watchActions } = useBusinessLayer();

	useEffect(() => {
		//this is handling tabs that are open
		channelLogoutRunning.onmessage = (msg) => {
			//if a logout is done, we need to make sure all tabs reload to free their references against the IndexedDB
			//elsewise a new connection might not be properly established
			if (msg.phase === 'started') {
				setLogout(true);
			}
			if (msg.phase === 'ended') {
				window.location.reload();
			}
		};
	}, []);

	useEffect(() => {
		watchActions({
			types: UserActionTypes.SignOut,
			callback: () => {
				setLogout(true);
			},
		});
	}, [watchActions]);

	useEffect(() => {
		watchActions({
			types: [
				UserActionTypes.SignOutResult,
				UserActionTypes.DeleteCurrentUserResult,
			],
			callback: (action) => {
				// For account deletion, don't redirect - let the app handle navigation to account-deleted page
				if (action.type === UserActionTypes.DeleteCurrentUserResult) {
					return;
				}
				// For regular sign out, redirect to root
				window.location.replace('/');
			},
		});
	}, [watchActions]);

	return isLogout ? logoutEl : children;
};
